export default __webpack_public_path__ + "static/media/partnership-1.84a42e7b.png";